<template>
  <div class>
    <v-row class="header-state-view">
      <v-col cols="12" class="py-0">
        <v-card-title class="py-3 headline white--text" primary-title>{{
          $t('lbl.monitoring.uploadFileViewPop.page_header')
        }}</v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card class="pa-6 monitor-bizfile-layout-container">
          <v-card-text class="mb-2 pa-0">
            <v-row class="r-popup-content">
              <v-col cols="12" sm="6" class="grid-pd">
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col cols="12" sm="4" class="grid-pd pa-0 flex align-center">
                    <v-btn
                      small
                      class="btn btn-save-file mr-1"
                      @click.stop.prevent="
                        copyToClipboard('I');
                        overlayIn = !overlayIn;
                      "
                    >
                      {{ $t('lbl.fileViewPop.copyToClipboard') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="4" class="grid-pd pa-0">
                    <v-checkbox
                      label="Original File View"
                      solo
                      hide-details
                      class="pa-0 ma-0"
                      dense
                      v-model="isOriginSource"
                      @change="changeViewType('I')"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" class="grid-pd pa-0 flex align-center">
                    <v-select
                      v-model="encodingIn"
                      dense
                      solo
                      :placeholder="$t('lbl.fileViewPop.selectCharSet')"
                      :items="encodings"
                      :disabled="!this.readonlyModeStatus"
                      @change="doCharSet('I')"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="v-grid-content">
                  <v-col class="pa-0">
                    <v-row class="no-gutters">
                      <div :class="['CodeMirror', isJsonFile ? 'json-color-format' : '']">
                        <EDIViewer v-model="inputFileContents" :options="cmOption_in"></EDIViewer>
                        <input type="hidden" id="inputFileContentsHdn" />
                        <v-overlay :absolute="absolute" :value="overlayIn">
                          <v-btn color="success" @click="overlayIn = false">{{ this.inMsg }}</v-btn>
                        </v-overlay>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" class="grid-pd">
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col cols="12" sm="4" class="grid-pd pa-0 flex align-center">
                    <v-btn
                      small
                      class="btn btn-save-file mr-1"
                      @click.stop.prevent="
                        copyToClipboard('O');
                        overlayOut = !overlayOut;
                      "
                    >
                      {{ $t('lbl.fileViewPop.copyToClipboard') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="4" class="grid-pd pa-0">
                    <v-checkbox
                      label="Original File View"
                      solo
                      hide-details
                      class="pa-0 ma-0"
                      dense
                      v-model="isOriginTarget"
                      @change="changeViewType('O')"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" class="grid-pd pa-0 flex align-center">
                    <v-select
                      v-model="encodingOut"
                      dense
                      solo
                      :placeholder="$t('lbl.fileViewPop.selectCharSet')"
                      :items="encodings"
                      @change="doCharSet('O')"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="v-grid-content">
                  <v-col class="pa-0">
                    <v-row class="no-gutters">
                      <div :class="['CodeMirror', isJsonOutFile ? 'json-color-format' : '']">
                        <BIZViewer v-model="outputFileContents" :options="cmOption_out"></BIZViewer>
                        <input type="hidden" id="outputFileContentsHdn" />
                        <v-overlay :absolute="absolute" :value="overlayOut">
                          <v-btn color="success" @click="overlayOut = false">{{
                            this.outMsg
                          }}</v-btn>
                        </v-overlay>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row class="mr-0 merge-button-group">
            <v-col
              :class="[
                'mt-1 button-col action-col pa-0',
                $vuetify.breakpoint.smAndDown ? '' : 'mr-2',
              ]"
              lg="6"
            >
              <div class="btn-form-control text-right">
                <v-btn
                  v-if="this.readonlyModeStatus && $auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    editMode();
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.editmode') }}
                </v-btn>
                <v-btn
                  v-if="!this.readonlyModeStatus && $auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    viewMode();
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.viewmode') }}
                </v-btn>
                <v-btn
                  v-if="$auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    reTranslation(inputFileContents);
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.retrslt') }}
                </v-btn>
                <v-btn class="btn btn-active mr-2" @click="downloadInputFile">
                  {{ $t('btn.common.download') }}
                </v-btn>
              </div>
            </v-col>
            <v-col class="mt-1 button-col action-col pa-0" lg="6">
              <div class="btn-form-control text-right">
                <v-btn
                  v-if="$auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    reTransmission(outputFileContents);
                    overlayOut = !overlayOut;
                  "
                >
                  {{ $t('btn.common.retrsms') }}
                </v-btn>
                <v-btn
                  class="btn btn-active mr-2"
                  @click="
                    downloadFileView(outputFileContentsHdn, fileViewInfo.record.targetFileName)
                  "
                >
                  {{ $t('btn.common.download') }}
                </v-btn>
                <v-btn class="btn btn-delete" @click="closeWindow('btn-close')">
                  {{ $t('btn.common.close') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import EDIViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import { mapState } from 'vuex';

// language
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

var encoding = require('encoding');

export default {
  components: {
    EDIViewer,
    BIZViewer,
  },
  name: 'monitoring-file-view-window',
  data: () => ({
    absolute: true,
    overlayIn: false,
    overlayOut: false,
    inputFilePath: '',
    outputFilePath: '',
    inputFileContents: '',
    inputFileContentsHdn: '',
    outputFileContents: '',
    outputFileContentsHdn: '',
    encodingIn: '',
    encodingOut: '',
    encodings: [
      { text: 'Character Set', value: '' },
      { text: 'UTF-8', value: 'UTF-8' },
      { text: 'ASCII', value: 'ASCII' },
      { text: 'ISO-8859-1', value: 'ISO-8859-1' },
      { text: 'ISO-8859-15', value: 'ISO-8859-15' },
      { text: 'EUC-KR', value: 'EUC-KR' },
      { text: 'EUC-JP', value: 'EUC-JP' },
      { text: 'GB2312', value: 'GB2312' },
      { text: 'UTF-16LE', value: 'UTF-16LE' },
      { text: 'BASE64', value: 'BASE64' },
    ],
    inMsg: '',
    outMsg: '',

    userData: {},
    tmpListData: [],
    masterSearchItems: {
      header: ['ADMIN_YN', 'CUST_ID'],
      data: [
        {
          ADMIN_YN: '',
          CUST_ID: '',
        },
      ],
    },
    inputFileContentCheck: '',
    listData: [],
    fileViewInfo: {},
    readonlyModeStatus: true,
    isJsonFile: false,
    isJsonOutFile: false,
    isOriginSource: false,
    isOriginTarget: false,
  }),
  computed: {
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    cmOption_in() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: this.readonlyModeStatus,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: this.readonlyModeStatus,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    cmOption_out() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
  },
  methods: {
    changeViewType(dir) {
      if (dir === 'I') {
        if (this.isOriginSource) {
          this.encodingIn = '';
          this.inputFileContents = this.inputFileContentsHdn;
        } else {
          if (this.isJson(this.inputFileContentsHdn)) {
            this.inputFileContents = JSON.stringify(JSON.parse(this.inputFileContentsHdn), null, 4);
          } else {
            this.inputFileContents = this.convertFollowMessage(this.inputFileContentsHdn);
          }
        }
      } else {
        if (this.isOriginTarget) {
          this.encodingOut = '';

          this.outputFileContents = this.outputFileContentsHdn;
        } else {
          if (this.isJson(this.outputFileContentsHdn)) {
            this.outputFileContents = JSON.stringify(
              JSON.parse(this.outputFileContentsHdn),
              null,
              4,
            );
          } else {
            this.outputFileContents = this.convertFollowMessage(this.outputFileContentsHdn);
          }
        }
      }
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    initialize() {
      this.inputFilePath = this.fileViewInfo.record.transInput.fileLink;
      this.outputFilePath = this.fileViewInfo.record.transOutput.fileLink;

      this.$store.dispatch('getinputFileContens', this.inputFilePath).then(() => {
        if (this.$store.getters.inputFileContents != null) {
          let rslt = this.$store.getters.inputFileContents;
          if (this.isJson(rslt)) {
            this.inputFileContents = JSON.stringify(JSON.parse(rslt), null, 4);
            this.isJsonFile = true;
          } else {
            this.inputFileContents = this.convertFollowMessage(rslt);
            this.isJsonFile = false;
          }
          this.inputFileContentsHdn = rslt;
          this.inputFileContentCheck = rslt;
        }
      });

      this.$store.dispatch('getoutputFileContens', this.outputFilePath).then(() => {
        if (this.$store.getters.outputFileContents != null) {
          let rslt = this.$store.getters.outputFileContents;
          if (this.isJson(rslt)) {
            this.outputFileContents = JSON.stringify(JSON.parse(rslt), null, 4);
            this.isJsonOutFile = true;
          } else {
            this.outputFileContents = this.convertFollowMessage(rslt);
            this.isJsonOutFile = false;
          }
          this.outputFileContentsHdn = rslt;
        }
      });
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    convertFollowMessage(input) {
      let replace = '';
      if (input.match(/^ISA\*/g)) {
        replace = input.replace(/~/g, '~\n');
      } else if (input.match(/^UNB\+/g) || input.match(/^\s*(?:UNA.{5}')?/g)) {
        replace = input.replace(/'/g, "'\n");
      } else {
        replace = input.replace(/'/g, '\n');
      }
      return replace;
    },
    downloadInputFile() {
      let sourceFileName = this.fileViewInfo.record.sourceFileName;

      this.$store.dispatch('getinputFileContens', this.inputFilePath).then(() => {
        if (this.$store.getters.inputFileContents != null) {
          let rslt = this.$store.getters.inputFileContents;
          this.downloadFileView(rslt, sourceFileName);
        }
      });
    },
    downloadFileView(content, title) {
      var data = new Blob([content], { type: 'text/plain' });
      var url = window.URL.createObjectURL(data);
      var a = document.createElement('a');
      a.href = url;
      a.download = title;
      document.body.appendChild(a);
      a.click();
    },
    reTranslation(content) {
      this.fileViewInfo.reAction = 'ReTranslation';
      this.$store
        .dispatch('getData4ReTranslationOrReTransmission', this.fileViewInfo)
        .then((res) => {
          res[0].header.targetFileName = '';
          res[0].payload.resourceId = '';
          res[0].payload.taskId = '';
          if (
            this.inputFileContentCheck.localeCompare(this.inputFileContents) !== 0 &&
            !this.readonlyModeStatus
          ) {
            res[0].payload.fileContent = this.inputFileContents;
            this.checkEdit = false;
          }
          this.$store.dispatch('execReTranslation', { data: res }).then(() => {
            this.inMsg = 'ReTranslation is complete.';
          });
        });
    },
    reTransmission(content) {
      this.fileViewInfo.reAction = 'ReTransmission';
      this.$store
        .dispatch('getData4ReTranslationOrReTransmission', this.fileViewInfo)
        .then((res) => {
          this.$store.dispatch('execReTransmission', { data: res }).then(() => {
            this.outMsg = 'ReTransmission is complete.';
          });
        });
    },
    editMode() {
      this.readonlyModeStatus = false;
      this.inMsg = 'Editable';
    },
    viewMode() {
      this.readonlyModeStatus = true;
      this.inMsg = 'Non-editable';
      this.inputFileContentsHdn = this.inputFileContents;
    },
    doCharSet(dir) {
      if (dir === 'I' && this.encodingIn !== undefined && this.encodingIn !== '') {
        var result = encoding.convert(this.inputFileContentsHdn, this.encodingIn);
        this.inputFileContents = result.toString();
        let data = this.inputFileContentCheck;
        let rs2 = encoding.convert(data, this.encodingIn);
        this.inputFileContentCheck = rs2.toString();
      } else if (dir === 'O' && this.encodingOut !== undefined && this.encodingOut !== '') {
        var result = encoding.convert(this.outputFileContentsHdn, this.encodingOut);
        this.outputFileContents = result.toString();
      }
    },
    copyToClipboard(dir) {
      let constents = '';
      if (dir === 'I') constents = this.inputFileContents;
      else constents = this.outputFileContents;

      if (window.clipboardData !== undefined) {
        window.clipboardData.setData('text', constents);
      } else {
        var t = document.createElement('textarea');
        document.body.appendChild(t);
        t.value = constents;
        t.select();
        document.execCommand('copy');
        document.body.removeChild(t);
      }
      if (dir === 'I') this.inMsg = 'Copied !!!';
      if (dir === 'O') this.outMsg = 'Copied !!!';
    },
  },

  created() {
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.fileViewInfo = param['options'].dataValue;
    this.$auth = param['options'].auth;
    this.initialize();
  },
};
</script>

<style>
.monitor-bizfile-layout-container .CodeMirror-gutters {
  left: 0 !important;
}
.monitor-bizfile-layout-container .CodeMirror-gutter-wrapper {
  left: -36px !important;
}
.monitor-bizfile-layout-container .v-grid-title .v-input {
  height: auto !important;
}
.monitor-bizfile-layout-container .v-grid-title .v-input .v-input__slot {
  height: 40px !important;
}
.theme--light .monitor-bizfile-layout-container .v-grid-title .v-input {
  background: #ffffff;
}
.theme--dark .monitor-bizfile-layout-container {
  background-color: #3b3e49 !important;
}
.monitor-bizfile-layout-container .v-grid-content {
  height: 528px;
  background-color: #2a2c35;
}
.theme--dark .monitor-bizfile-layout-container .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
}
.monitor-bizfile-layout-container .v-grid-title .v-input.v-input--checkbox .v-label {
  font-size: 12px;
  font-weight: 400;
}
.monitor-bizfile-layout-container .v-grid-title .v-input.v-input--checkbox {
  border: none;
  background: inherit;
}
.v-select {
  padding: 0 !important;
}
</style>
